'use strict';
import * as $j_java$002elang$002e$002dFloat$0024 from "./java.lang.-Float$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002emath$002e$002dConversion$0024 from "./java.math.-Conversion$.js";
var $p;
function $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveHashcode__I($thiz) {
  var $x_1 = $thiz.gB();
  var lv_$_lo = $x_1.l;
  var lv_$_hi = $x_1.h;
  return ((((lv_$_hi === (-1)) ? ((lv_$_lo >>> 0) >= 2147483648) : (lv_$_hi > (-1))) && ((lv_$_hi === 0) ? ((lv_$_lo >>> 0) <= 2147483647) : (lv_$_hi < 0))) ? lv_$_lo : $j_java$002elang$002e$002dObject.$m_sr_Statics$().PB(lv_$_lo, lv_$_hi));
}
export { $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveHashcode__I as $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveHashcode__I };
function $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z($thiz, x) {
  if ((x instanceof $j_java$002elang$002e$002dObject.$Char)) {
    var x8 = $j_java$002elang$002e$002dObject.$uC(x);
    return ($thiz.Vu() && ($thiz.r5() === x8));
  } else if ($j_java$002elang$002e$002dObject.$isByte(x)) {
    var x7 = (x | 0);
    return ($thiz.Vt() && ((($thiz.r5() << 24) >> 24) === x7));
  } else if ($j_java$002elang$002e$002dObject.$isShort(x)) {
    var x6 = (x | 0);
    return ($thiz.VA() && ((($thiz.r5() << 16) >> 16) === x6));
  } else if ($j_java$002elang$002e$002dObject.$isInt(x)) {
    var x5 = (x | 0);
    return ($thiz.Vx() && ($thiz.r5() === x5));
  } else if ((x instanceof $j_java$002elang$002e$002dObject.$Long)) {
    var $x_1 = $j_java$002elang$002e$002dObject.$uJ(x);
    var x4_$_lo = $x_1.l;
    var x4_$_hi = $x_1.h;
    var $x_2 = $thiz.gB();
    var x$1_$_lo = $x_2.l;
    var x$1_$_hi = $x_2.h;
    return (((x$1_$_lo ^ x4_$_lo) | (x$1_$_hi ^ x4_$_hi)) === 0);
  } else if ($j_java$002elang$002e$002dObject.$isFloat(x)) {
    var x3 = Math.fround(x);
    return ($j_java$002elang$002e$002dFloat$0024.$m_jl_Float$().PR($j_java$002emath$002e$002dConversion$0024.$m_Ljava_math_Conversion$().rp($thiz.kN())) === x3);
  } else if (((typeof x) === "number")) {
    var x2 = (+x);
    return ($thiz.OK() === x2);
  } else {
    return false;
  }
}
export { $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z as $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z };
